import React, { useState, useEffect } from "react";
import { isMobile } from 'lib/checkuseros';

import { listOfChannels } from "./config";
import { AutoSlider } from "./сomponents";

import Button from "../button";
import QrPopup from "../ui/qr-popup";

import { translate } from "react-polyglot";
import useMediaQuery from "../../../../hooks/useMediaQuery";


import "./styles.less";

const BlockSlider = ({ t, registrationRedirectionURL }) => {
  const [isPopupOpened, setIsPopupOpened] = useState(false);

  const handleRegistrationClick = () => {
    if (isMobile()) {
      window.location.assign(`${window.location.origin}/redirects/checkos_redirect.html`);
      return;
    }

    window.location.assign(registrationRedirectionURL);
  };


  return (
    <div className="block-slider__container">
      {
        isPopupOpened &&
        <QrPopup
          closePopup={() => setIsPopupOpened(false)}
          actionButtonClick={handleRegistrationClick}
        />
      }
      <div className="block-slider__inner-wrapper">
        <div className="block-slider__with-container">
          <p className="block-slider__title">{t("landing.block-slider.title")}</p>
          <p className="block-slider__subtitle">{t("landing.block-slider.subtitle")}</p>
        </div>

        <div className="block-slider__channels block-slider__with-container">
          {listOfChannels.map(({ name, img }) => (
            <div key={name} className="block-slider__channel">
              <img className="block-slider__channel-img" alt={name} src={img} name={name} />
            </div>
          ))}
        </div>

        <div className="block-slider__slider">
          <AutoSlider
            paused={isPopupOpened}
            actionButtonText={t("landing.block-slider.registration")}
            onCardButtonClick={() => setIsPopupOpened(true)}
          />
        </div>

        <div className="block-slider__button block-slider__with-container">
          <Button
            handleClick={handleRegistrationClick}
            text={t("landing.block-slider.registration")}
            variant="default"
            size="lg"
          />
        </div>
      </div>
    </div>
  );
};

export default translate()(BlockSlider);



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-slider/index.js